import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Pulse } from 'easyship-components';
import { useEffect, useState } from 'react';

import { ErrorPage } from '@/pages/ErrorPage';

interface StripeProviderProps {
  children: React.ReactNode;
  publishableKey: string;
  clientSecret?: string;
}

export const StripeProvider = ({ children, publishableKey, clientSecret }: StripeProviderProps) => {
  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null> | null>(null);
  const [errorMessageId, setErrorMessageId] = useState<string>();

  useEffect(() => {
    if (publishableKey) {
      try {
        setStripePromise(loadStripe(publishableKey));
      } catch (err) {
        setErrorMessageId('errors.failed-to-load-stripe');
      }
    }
  }, [publishableKey]);

  if (errorMessageId) {
    return <ErrorPage errorMessageId={errorMessageId} />;
  }

  if (!stripePromise) {
    return <Pulse />;
  }

  return (
    <Elements
      stripe={stripePromise}
      options={
        clientSecret
          ? {
              clientSecret,
              appearance: {
                theme: 'stripe',
                variables: {
                  fontFamily: '"Karla", sans-serif',
                },
              },
              fonts: [
                {
                  cssSrc: 'https://fonts.googleapis.com/css2?family=Karla&display=swap',
                },
              ],
              loader: 'always',
            }
          : undefined
      }
    >
      {children}
    </Elements>
  );
};
